module.exports = __webpack_public_path__ + "static/media/visibilityIcon.9234b20f.svg";